module.exports = __webpack_public_path__ + "static/img/9.ff34a6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/sp/9.png
// module id = STNg
// module chunks = 0